import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  ADD_ASPIRATIONS_QUESTION,
  EDIT_ASPIRATIONS_QUESTION,
  VIEW_ASPIRATIONS_QUESTION,
  LIST_ASPIRATIONS_QUESTION,
  DELETE_ASPIRATIONS_QUESTION,
  ADD_ASPIRATIONS_TEXT,
  EDIT_ASPIRATIONS_TEXT,
  VIEW_ASPIRATIONS_TEXT,
  LIST_ASPIRATIONS_TEXT,
  DELETE_ASPIRATIONS_TEXT
} from "./actionTypes"
import { aspirationSuccess, aspirationError } from "./actions"


import {
  onAddAspirationsQuestion,
  onEditAspirationsQuestion,
  onViewAspirationsQuestion,
  onListAspirationsQuestion,
  onDeleteAspirationsQuestion,
  onAddAspirationsText,
  onEditAspirationsText,
  onListAspirationsText,
  onViewAspirationsText,
  onDeleteAspirationsText
} from "helpers/backend_api_helper";

// add aspiration question
function* addAspirationQuestion({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddAspirationsQuestion, data);
    yield put(aspirationSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// edit aspiration question
function* editAspirationQuestion({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditAspirationsQuestion, data, id);
    yield put(aspirationSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// list aspiration question
function* listAspirationQuestion({ payload: { data, callback } }) {
  try {
    let response = yield call(onListAspirationsQuestion, data);
    yield put(aspirationSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// view aspiration question
function* viewAspirationQuestion({ payload: { data, history } }) {
  try {
    const response = yield call(onViewAspirationsQuestion, data);
    yield put(aspirationSuccess(response));

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// delete aspiration question
function* deleteAspirationQuestion({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteAspirationsQuestion, data);
    yield put(aspirationSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add aspiration question
function* addAspirationText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddAspirationsText, data);
    yield put(aspirationSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// edit aspiration question
function* editAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditAspirationsText, data, id);
    yield put(aspirationSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// list aspiration question
function* listAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListAspirationsText, data, id);
    yield put(aspirationSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// view aspiration question
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewAspirationsText, data);
    yield put(aspirationSuccess(response));

  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}

// delete aspiration question
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteAspirationsText, data);
    yield put(aspirationSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(aspirationError(error?.response?.data?.message || "Server Error"));
  }
}



function* aspirationsQuestionSaga() {
  yield takeEvery(ADD_ASPIRATIONS_QUESTION, addAspirationQuestion);
  yield takeEvery(EDIT_ASPIRATIONS_QUESTION, editAspirationQuestion);
  yield takeEvery(LIST_ASPIRATIONS_QUESTION, listAspirationQuestion);
  yield takeEvery(VIEW_ASPIRATIONS_QUESTION, viewAspirationQuestion);
  yield takeEvery(DELETE_ASPIRATIONS_QUESTION, deleteAspirationQuestion);

  // text
  yield takeEvery(ADD_ASPIRATIONS_TEXT, addAspirationText);
  yield takeEvery(EDIT_ASPIRATIONS_TEXT, editAspirationText);
  yield takeEvery(LIST_ASPIRATIONS_TEXT, listAspirationText);
  yield takeEvery(VIEW_ASPIRATIONS_TEXT, viewAspirationText);
  yield takeEvery(DELETE_ASPIRATIONS_TEXT, deleteAspirationText);
}

export default aspirationsQuestionSaga;

